import { render, staticRenderFns } from "./o-search.vue?vue&type=template&id=4cb65f9f&"
import script from "./o-search.vue?vue&type=script&lang=js&"
export * from "./o-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports